import { Button, ButtonTheme } from '@apply/components';

export const CloseButton = () => {
    return (
        <>
            <Button
                id='closeButton'
                theme={ButtonTheme.Tertiary}
                width='220px'
                height='48px'
                type='button'
                handleClick={() => (window.location.href = '/')}
            >
                Close
            </Button>
        </>
    );
};
